import PaymentCardList from './PaymentCardList'

export default PaymentCardList
